module.exports = __webpack_public_path__ + "img/play-back2.a1aa6b85.png";